import "./loan-sections.css";

const CRITERIA = [
  {
    icon: "fa-user",
    title: "Age",
    text: "21 to 60 years",
  },
  {
    icon: "fa-indian-rupee-sign",
    title: "Income",
    text: "Minimum monthly income as per loan type",
  },
  {
    icon: "fa-briefcase",
    title: "Employment Type",
    text: "Salaried / Self-Employed / Business Owners",
  },
  {
    icon: "fa-chart-line",
    title: "Credit Score",
    text: "Good credit score improves your chances",
  },
  {
    icon: "fa-flag",
    title: "Nationality",
    text: "Indian Resident",
  },
];

export default function LoanEligibility() {
  return (
    <section className="loan-elig">
      <div className="loan-elig-inner">
        <header className="loan-section-head">
          <p className="loan-eyebrow">ELIGIBILITY CRITERIA</p>
          <h2>Check Your Loan Eligibility in Minutes</h2>
        </header>

        <div className="loan-elig-grid">
          <ul className="loan-elig-list">
            {CRITERIA.map((item) => (
              <li key={item.title}>
                <span className="loan-elig-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.text}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="loan-elig-visual">
            <img
              src="/images/loan-eligibility-check.png"
              alt="Eligibility checklist illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
